import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center w-100 ga-4 mb-3" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "d-flex align-center w-100 ga-4" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "pt-3" }

import {ref, computed, reactive} from 'vue'
import moment from "moment/moment";
import {consultationService} from "@/api/services/consultation";
import {useRoute, useRouter} from "vue-router";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsPage',
  props: {
  state: Object,
  userStore: Object,
  packageServiceId: Number,
},
  setup(__props) {

const router = useRouter();
const route = useRoute();

const props = __props

const state = reactive({
  user: props.userStore.user,
})

const creatingBooking = ref(false);

const isBookingReady = computed(() => {
  if (props.state.booking.method && props.state.booking.date && props.state.booking.time && props.state.booking.practitioner && props.state.booking.termsAgreed) {
    return true;
  }
  return false;
});

const createBooking = () => {
  if (creatingBooking.value) {
    return;
  }

  creatingBooking.value = true;

  const date = props.state.booking.date;
  const time = props.state.booking.time;

  const formattedDate = moment(date).format('DD/MM/YY');

  const datetimeString = `${formattedDate} ${time}`;

  const timezone = props.userStore.user.clinic.timezone || 'Europe/London';

  // Parse the combined date and time string in the user's local timezone
  const localDatetime = moment.tz(datetimeString, 'DD/MM/YY HH:mm', timezone);

  // Convert the local datetime to UTC
  const utcDatetime = localDatetime.utc();

  // Format the datetime to 'YYYY-MM-DD HH:mm:ss' format in UTC
  const formattedDatetime = utcDatetime.format('YYYY-MM-DD HH:mm:ss');

  let serviceOrPackageIds = {
    service_id: props.state.service.id,
  };

  if (props.state.service.clinic_service_id) {
    serviceOrPackageIds = {
      service_id: props.state.service.clinic_service_id,
      package_id: props.state.service.clinic_package_id,
      package_service_id: +props.packageServiceId,
    };
  }

  consultationService.create({
    ...serviceOrPackageIds,
    practitioner_id: props.state.booking.practitioner.id,
    method: props.state.booking.method,
    start_date: formattedDatetime,
    order_id: route.query.orderId,
    consultation_id: route.query.consultationId,
  }).then((response) => {
    router.push({name: 'order-view', params: {id: response.order.id}})
  }).catch((err) => {
    console.log(err);
  }).finally(() => {
    creatingBooking.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { class: "position-relative px-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_label, { class: "font-size-12-600 font-black mb-0" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("First Name", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: state.user.first_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.user.first_name) = $event)),
                density: "compact",
                disabled: "",
                elevation: "0",
                "hide-details": "",
                placeholder: "First Name",
                variant: "solo",
                width: "100%"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_label, { class: "font-size-12-600 font-black mb-0" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Last Name", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: state.user.last_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.user.last_name) = $event)),
                density: "compact",
                disabled: "",
                elevation: "0",
                "hide-details": "",
                placeholder: "Last Name",
                variant: "solo",
                width: "100%"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_label, { class: "font-size-12-600 font-black mb-0" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Email", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: state.user.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.user.email) = $event)),
                density: "compact",
                disabled: "",
                elevation: "0",
                "hide-details": "",
                placeholder: "Email",
                variant: "solo",
                width: "100%"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_label, { class: "font-size-12-600 font-black mb-0" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Phone Number", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: state.user.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.user.phone) = $event)),
                density: "compact",
                disabled: "",
                elevation: "0",
                "hide-details": "",
                placeholder: "Phone Number",
                variant: "solo",
                width: "100%"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_7, [
        _createVNode(ButtonFixed, {
          disabled: !isBookingReady.value || creatingBooking.value,
          "custom-class": "text-white primary-button confirm-button",
          text: "Complete Booking",
          width: "100%",
          onClick: createBooking
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})